var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile)?_c('div',{staticClass:"mobile-banner"},[_c('connect-domain-banner')],1):_vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }